import { Component, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'vs-slide-indicator',
  styleUrl: 'vs-slide-indicator.scss',
  shadow: false,
})
export class VsSlideIndicator {
  @Prop() totalSlides: number;
  @Prop() activeIndex: number;
  @Prop() value: number = 0;
  @Prop() disableTransition: boolean;
  @Prop() onSlideClick: (event: CustomEvent) => void;
  @Prop() onPlayPause: (event: CustomEvent) => void;
  @Prop() autoplayStatus: string;


  setActiveIndex(index: number) {
    this.onSlideClick(new CustomEvent('slideClick', { detail: index }));
  }

  toggleProgressTimer() {
    this.onPlayPause(new CustomEvent('toggleProgressTimer'));
  }
  componentDidLoad() {
    this.setActiveIndex(this.activeIndex);
  }


  render() {
    return (
      <Host>
        <ul role="tablist" aria-label="Choose slide to display" class="vs-carousel-controls vs-row vs-mx-0 vs-px-0 vs-mt-4 vs-list-none vs-justify-content-center">
          {!this.disableTransition && Array.from(Array(this.totalSlides).keys()).map((index) => {
            return (index === this.activeIndex) ? (
              <li tabindex="0" role="tab" class={`vs-carousel-control-item active`} aria-label={`Slide ${index + 1}`} onClick={() => this.setActiveIndex(index)} onKeyDown={(event) => {
                if (event.key === 'Enter') {
                  this.setActiveIndex(index);
                }
              }}>
                <vs-spinner value={this.value} size={17} diameter={17} ></vs-spinner>
              </li>)
              :
              (<li tabindex="0" role="tab" class={`vs-carousel-control-item`} aria-label={`Slide ${index + 1}`} onClick={() => this.setActiveIndex(index)} onKeyDown={(event) => {
                if (event.key === 'Enter') {
                  this.setActiveIndex(index);
                }
              }}>
                <span class="vs-carousel-circle"></span>
              </li>)
          })}
          {this.disableTransition && Array.from(Array(this.totalSlides).keys()).map((index) => {
            return (index === this.activeIndex) ? (
              <li tabindex="0" role="tab" class={`vs-carousel-control-item active`} aria-label={`Slide ${index + 1}`} onClick={() => this.setActiveIndex(index)} onKeyDown={(event) => {
                if (event.key === 'Enter') {
                  this.setActiveIndex(index);
                }
              }}>
                <span class="vs-carousel-circle vs-active"></span>
              </li>)
              :
              (<li tabindex="0" role="tab" class={`vs-carousel-control-item`} aria-label={`Slide ${index + 1}`} onClick={() => this.setActiveIndex(index)} onKeyDown={(event) => {
                if (event.key === 'Enter') {
                  this.setActiveIndex(index);
                }
              }}>
                <span class="vs-carousel-circle"></span>
              </li>)
          })}
          {!this.disableTransition &&
            <li tabindex="0" role="tab" class="play-pause vs-carousel-control-item ng-tns-c1-0 ng-star-inserted" onClick={() => this.toggleProgressTimer()} onKeyDown={(event) => {
              if (event.key === 'Enter') {
                this.toggleProgressTimer();
              }
            }} aria-label="Start slide rotation">
              <span class={`visa-icon vs-play-pause-icon ng-tns-c1-0 visa-icon-` + this.autoplayStatus}>
              </span>
            </li>
          }
        </ul>
      </Host>
    );
  }

}
